// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bk-W","importantInfo":"styles_importantInfo__1feZs"};